module.exports = __webpack_public_path__ + "media/dashboard/assets/images/profile_token-2d645f25c13bb37ec8f2ede4d7dff476.svg";